var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icona_Irrigazione",
    "data-name": "Icona Irrigazione",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "faucet",
    d: "M22,107H19.587A8.305,8.305,0,0,0,16,105.25v-2.972l-2-.211-2,.211v2.972A8.383,8.383,0,0,0,8.413,107H1a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H6.8a8.123,8.123,0,0,0,7.2,4,8.123,8.123,0,0,0,7.2-4H22a2,2,0,0,1,2,2,2,2,0,0,0,2,2h4a2,2,0,0,0,2-2A10,10,0,0,0,22,107ZM5.1,100.994l8.9-.938,8.9.938a1.022,1.022,0,0,0,1.1-1.05V98.056A1.022,1.022,0,0,0,22.9,97l-6.9.729V96a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v1.734L5.1,97A1.023,1.023,0,0,0,4,98.056v1.889A1.022,1.022,0,0,0,5.1,100.994Z",
    transform: "translate(0 -95)",
    fill: "#74788d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "card_body",
    x: -54.53,
    y: -24,
    width: 141.06,
    height: 96,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 12,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#12263f",
    floodOpacity: 0.031
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_1",
    "data-name": "Gruppo di maschere 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#card_body)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "card_body-2",
    "data-name": "card body",
    d: "M.171,0H68.89a.155.155,0,0,1,.171.131V23.869A.155.155,0,0,1,68.89,24H.171A.155.155,0,0,1,0,23.869V.131A.155.155,0,0,1,.171,0Z",
    transform: "translate(-18.53 0)",
    fill: "#74788d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTap);
export default __webpack_public_path__ + "static/media/tap.8782daae.svg";
export { ForwardRef as ReactComponent };